/*
  Project: Vivafloors
 */

// Videos from templates/components/inline-video.php play muted on a loop; a
// click starts them over with sound, with the controls to pause again.
document.addEventListener('DOMContentLoaded', () => {
  const reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.slice.call(document.querySelectorAll('.js-hero-video')).forEach(wrapper => {
    const video = wrapper.querySelector('.js-hero-video__player');
    const play = wrapper.querySelector('.js-hero-video__play');
    if (!video || !play) return;

    // No moving picture for visitors who asked for less motion; the poster
    // shows instead and the click still plays it.
    if (reduceMotion) {
      video.removeAttribute('autoplay');
      video.pause();
    }

    play.addEventListener('click', () => {
      video.loop = false;
      video.muted = false;
      video.controls = true;
      video.currentTime = 0;

      const playing = video.play();
      if (playing && playing.catch) {
        playing.catch(() => {});
      }

      play.hidden = true;
      wrapper.classList.add('is-playing');
    });
  });
});



// WEBPACK FOOTER //
// ./src/scripts/modules/heroVideo.js